import { render, staticRenderFns } from "./LuckyRoom.vue?vue&type=template&id=69ee873c&scoped=true&"
import script from "./LuckyRoom.vue?vue&type=script&lang=js&"
export * from "./LuckyRoom.vue?vue&type=script&lang=js&"
import style0 from "./LuckyRoom.vue?vue&type=style&index=0&id=69ee873c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69ee873c",
  null
  
)

export default component.exports